import yup from '@/libs/yup';

export default yup.object({
    name: yup.string(),
    email: yup.string().email().required(),
    role: yup.string().required(),
    tenant: yup.string()
});
